import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './school-teachers.styles.js'

import Paper from 'pobble-components/dist/paper'

import Container from '../../shared/container/container.jsx'
import Main from '../../shared/main/main.jsx'

import SchoolTeachersFilter from './teachers-filter/teachers-filter.container.js'
import SchoolTeachersList from './teachers-list/teachers-list.container.js'
import PendingTeachersList from './pending-teachers-list/pending-teachers-list.container.js'
import SectionTitle from '../../shared/section-title/section-title.jsx'

class Schools extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  render() {
    const { classes, sectionTitle } = this.props
    return (
      <Container>
        <Main>
          <Paper className={classes.container}>
            <SectionTitle title={sectionTitle} />
            <PendingTeachersList />
            <SchoolTeachersFilter />
            <SchoolTeachersList />
          </Paper>
        </Main>
      </Container>
    )
  }
}

export default injectSheet(styles)(Schools)
